import React from 'react';
import { Section } from '../Section';
import { TwoColumns } from '../Section/index';
// import sizes from 'src/style/sizes';
import { SectionTitle, SubtitleDescription } from '../Typography';
import BulletsPoints from '../CorporateCourses/BulletsPoints';
// import { StyledLinkA } from 'src/components/Typography';
// import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

/**
 * @type React.FunctionComponent<{ title: string}>
 */

const LearningAndTechno = React.memo(({ theme, title, id, diploma }) => {
  return (
    <Section theme={theme || 'light'} id={id}>
      <TwoColumns
        center
        // sizeLeft={sizes.columnWidth.small}
        sizeLeft={1}
        left={
          <div>
            <SectionTitle isMobileCenter>{title}</SectionTitle>
          </div>
        }
        // sizeRight={sizes.columnWidth.large}
        sizeRight={2}
        right={
          <div
            css={{
              paddingTop: 30,
              [mediaQueries.tabletLandscapeUp]: {
                paddingLeft: 60,
              },
            }}
          >
            {diploma === 'rncp5' ? (
              <>
                <SubtitleDescription style={{ marginBottom: '18px' }}>
                  Développer la partie front-end d'une application Web ou Web Mobile sécurisée
                </SubtitleDescription>
                <BulletsPoints
                  h3
                  content={[
                    'Installer et configurer son environnement de travail en fonction du projet Web ou Web Mobile',
                    'Maquetter des interfaces utilisateur Web ou Web Mobile',
                    'Réaliser des interfaces utilisateur statiques Web ou Web Mobile',
                    'Développer la partie dynamique des interfaces utilisateur Web ou Web Mobile',
                  ]}
                />
                <SubtitleDescription style={{ marginBottom: '18px', marginTop: '18px' }}>
                  Développer la partie back-end d'une application Web ou Web Mobile sécurisée{' '}
                </SubtitleDescription>
                <BulletsPoints
                  h3
                  content={[
                    'Mettre en place une base de données relationnelle',
                    "Développer des composants d'accès aux données SQL et NoSQL",
                    'Développer des composants métier côté serveur',
                    "Documenter le déploiement d'une application dynamique Web ou Web Mobile",
                  ]}
                />
              </>
            ) : (
              <BulletsPoints
                h3
                content={[
                  'Découvrir et maîtriser les bases de la programmation JavaScript',
                  'Utiliser les outils de développement',
                  'Développer des sites Internet “responsive”',
                  'Créer des serveurs (APIs) et les déployer',
                  'Concevoir et administrer des bases de données situées dans le Cloud',
                  'Installer, configurer et utiliser des bibliothèques JavaScript',
                  'Utiliser la bibliothèque React pour la création de sites Web dynamiques',
                  'Utiliser les outils d’intelligence artificielle pour coder efficacement',
                  'Construire des applications Mobile pour iOS et Android avec React Native',
                ]}
              />
            )}
          </div>
        }
      />
    </Section>
  );
});

export default LearningAndTechno;
